import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "page-header" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = {
  key: 0,
  class: "page-subtitle"
}

import { useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'VendorDashboardHeader',
  props: {
    title: {},
    subtitle: {}
  },
  setup(__props: any) {

const props = __props;
const router = useRouter();

function handleBack() {
  if (window.history.length > 1) {
    router.back();
    return;
  }
  router.push({ name: "vendor.dashboard" });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.title), 1),
    (__props.subtitle)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.subtitle), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})